export const MAX_REPORT_EVIDENCES = 20;
export const MAX_EVIDENCE_FILE_BYTES = 5 * 1024 * 1024;
export const MAX_EVIDENCE_DESCRIPTION_LENGTH = 500;

const ALLOWED_EVIDENCE_TYPES = new Set([
  'image/jpeg',
  'image/png',
]);

const extensionOf = (name) => {
  const match = String(name || '').toLowerCase().match(/\.([a-z0-9]+)$/);
  return match ? match[1] : '';
};

export const isAllowedEvidenceFile = (file) => {
  if (!file) return false;
  const type = String(file.type || '').toLowerCase();
  const extension = extensionOf(file.name);
  return (
    ALLOWED_EVIDENCE_TYPES.has(type) &&
    ['jpg', 'jpeg', 'png'].includes(extension)
  );
};

export const validateEvidenceFiles = (files = [], currentCount = 0) => {
  const normalized = Array.from(files || []);
  if (normalized.length === 0) {
    return { files: [], error: 'Selecciona al menos una imagen.' };
  }

  if (currentCount + normalized.length > MAX_REPORT_EVIDENCES) {
    return {
      files: [],
      error: `El reporte admite como máximo ${MAX_REPORT_EVIDENCES} evidencias.`,
    };
  }

  const invalidType = normalized.find((file) => !isAllowedEvidenceFile(file));
  if (invalidType) {
    return {
      files: [],
      error: `${invalidType.name || 'Uno de los archivos'} no es JPG, JPEG o PNG válido.`,
    };
  }

  const oversized = normalized.find(
    (file) => Number(file.size || 0) > MAX_EVIDENCE_FILE_BYTES,
  );
  if (oversized) {
    return {
      files: [],
      error: `${oversized.name || 'Uno de los archivos'} supera el límite de 5 MB.`,
    };
  }

  return { files: normalized, error: null };
};

export const validateEvidenceMetadata = ({ descripcion = '', fecha_evidencia = '' } = {}) => {
  const errors = {};
  if (String(descripcion || '').length > MAX_EVIDENCE_DESCRIPTION_LENGTH) {
    errors.descripcion = `La descripción no puede superar ${MAX_EVIDENCE_DESCRIPTION_LENGTH} caracteres.`;
  }

  if (
    fecha_evidencia &&
    !/^\d{4}-\d{2}-\d{2}$/.test(String(fecha_evidencia))
  ) {
    errors.fecha_evidencia = 'La fecha de evidencia no es válida.';
  }

  return errors;
};

export const moveEvidence = (evidences = [], fromIndex, toIndex) => {
  if (
    fromIndex < 0 ||
    toIndex < 0 ||
    fromIndex >= evidences.length ||
    toIndex >= evidences.length ||
    fromIndex === toIndex
  ) {
    return [...evidences];
  }

  const next = [...evidences];
  const [moved] = next.splice(fromIndex, 1);
  next.splice(toIndex, 0, moved);
  return next;
};

export const buildEvidenceOrderPayload = (evidences = []) =>
  evidences.map((item) => Number(item.id_evidencia));

export const formatEvidenceSize = (bytes) => {
  const numeric = Number(bytes || 0);
  if (!Number.isFinite(numeric) || numeric <= 0) return '0 KB';
  if (numeric < 1024 * 1024) return `${Math.max(1, Math.round(numeric / 1024))} KB`;
  return `${(numeric / (1024 * 1024)).toFixed(1)} MB`;
};
